import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { LocalizedLink } from "@/components/LocalizedLink";
import {
  getStoredConsent,
  setStoredConsent,
  loadAnalytics,
  hasAnalyticsConsent,
} from "@/lib/consent";

/**
 * GDPR cookie banner.
 * Analytics only loads after an explicit "Accept" — opt-in, not opt-out.
 * NOTE: reasonable default implementation, not legal advice.
 */
const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (hasAnalyticsConsent()) {
      loadAnalytics();
      return;
    }
    if (getStoredConsent() === null) setVisible(true);
  }, []);

  const accept = () => {
    setStoredConsent("accepted");
    loadAnalytics();
    setVisible(false);
  };

  const reject = () => {
    setStoredConsent("rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-[60] border-t border-border bg-background shadow-lg"
    >
      <div className="container mx-auto flex flex-col gap-3 px-4 py-3 sm:px-6 md:flex-row md:items-center md:gap-4">
        <p className="text-sm text-muted-foreground font-inter flex-1">
          We use essential cookies to run this site and, with your consent, analytics cookies
          to understand how it is used. You can change your mind at any time. Read our{" "}
          <LocalizedLink to="/privacy-policy" className="underline text-accent hover:opacity-80">
            Privacy Policy
          </LocalizedLink>
          .
        </p>
        <div className="grid grid-cols-2 gap-3 shrink-0 sm:flex">
          <Button variant="outline" onClick={reject} className="min-h-[44px] font-inter">
            Necessary only
          </Button>
          <Button
            onClick={accept}
            className="min-h-[44px] bg-accent hover:bg-accent/90 text-accent-foreground font-inter font-semibold"
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
